import React, { useEffect, useReducer } from "react";

export const actionTypes = {
  isPlayerLoaded: 'isPlayerLoaded',
  count: 'count',
  isVideoPlaying: 'isVideoPlaying',
  isTimerRunning: 'isTimerRunning',
  currentVideoPos: 'currentVideoPos',
  currentVideoSlug: 'currentVideoSlug',
  disableUrlFragment: 'disableUrlFragment'
};

export function videoReducer(state, action) {
  switch (action.type) {
    case actionTypes.isPlayerLoaded: {
      return { ...state, isPlayerLoaded: action.payload };
    }
    case actionTypes.isVideoPlaying: {
      return { ...state, isVideoPlaying: action.payload };
    }
    case actionTypes.count: {
      return { ...state, count: action.payload };
    }

    case actionTypes.isTimerRunning: {
      return { ...state, isTimerRunning: action.payload };
    }
    case actionTypes.currentVideoPos: {
      const position = action.payload;
      const { videoList, currentVideo: prevVideo } = state || {};

      const currentVideo = videoList[position];
      const isAccountIdChanged = currentVideo?.fields?.brightcoveAccountId !== prevVideo?.fields?.brightcoveAccountId;
      return { ...state, currentVideoPos: position, currentVideo, isAccountIdChanged };
    }

    case actionTypes.reset: {
      return { ...state, ...action.payload };
    }

    case actionTypes.disableUrlFragment: {
      return { ...state, disableUrlFragment: action.payload };
    }

    default: {
      throw new Error(`Unsupported type: ${action.type}`);
    }
  }
}

export function useVideo({ initialState, reducer = videoReducer } = {}) {
  const hashedVideoSlug = location.hash
    ? location.hash.replace('#', '')
    : null;

  const { videoList, initialVideoPosition } = initialState || {};

  const currentVideoPos = initialVideoPosition || initialVideoPosition === 0
    ? initialVideoPosition
    : hashedVideoSlug
      ? videoList.findIndex(video => video.slug === hashedVideoSlug)
      : 0;

  const { current: currentState } = React.useRef({
    ...initialState,
    currentVideoPos,
    currentVideo: videoList[currentVideoPos]
  });

  const [state, dispatch] = useReducer(reducer, currentState);

  const { currentVideo, isAccountIdChanged, disableUrlFragment } = state || {};

  useEffect(() => {
    if (currentVideo && !disableUrlFragment) {
      const state = { 'video': currentVideo.title };
      const title = currentVideo.title || "";
      const url = `#${currentVideo?.slug}`;
      history.pushState(state, title, url);
    }
  }, [currentVideo, isAccountIdChanged, disableUrlFragment]);

  const updateVideo = ({ type, payload }) => dispatch({ type, payload });
  const reset = (payload) => dispatch({ type: 'reset', payload });

  return {
    state,
    reset,
    updateVideo
  };
}
